import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const SegmentsService = {
  async getSegments(page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get('segment/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getSegmentDetails(segmentId) {
    const res = await axios.get(`segment/${segmentId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getSegmentsSelect() {
    const res = await axios.get(`segment/select/no-pagination/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createSegment(data) {
    const res = await axios.post('segment/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async updateSegment(segmentId, data) {
    const res = await axios.put(`segment/${segmentId}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deleteSegment(segmentId) {
    const res = await axios.delete(`segment/${segmentId}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
